import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import cn from 'classnames';
import styles from './kdsExpoStationCards.module.scss';
import kdsStyles from '../common/KDSCSS/kdsScreens.module.scss'
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import ExpoTime from './expoTime';
import Modal from '@components/common/Modal';
import SearchComponent from '@components/common/search/SearchComponent';
import { getObjectValue } from '@utility/utills';
import { createFilter } from '@utility/helperFunction';
import Tooltip from './ToolTip';
import moment from 'moment';
import Navbar from '../common/Navbar/index.jsx';
import HamburgerSideBarMenu from '../common/HamburgerSideBarMenu/index';
import Footer from '../common/Footer/index';
import kdsDragIcon from '@assets/images/KDSICONS/kdsDrag.svg';
import kdsRushIcon from '@assets/images/KDSICONS/kdsRush.svg';
import checkBoxIcon from '@assets/images/KDSICONS/checkBox.svg';
import downArrow from '@assets/images/KDSICONS/downArrow.svg';
import upArrow from '@assets/images/KDSICONS/upArrow.svg';
import expand from '@assets/images/KDSICONS/expand.svg';
import checkIcon from '@assets/images/KDSICONS/checkIcon.svg';
import placeIcon from '@assets/images/KDSICONS/placeIcon.svg';
import prioritizeIcon from '@assets/images/KDSICONS/prioritizeIcon.svg';
import checkedInIcon from '@assets/images/KDSICONS/checkedInIcon.svg';
import NewIcon from '@assets/images/KDSICONS/newOrder.png';
import TicketExpandModal from './ticketExpand';
import { connect } from 'react-redux';
import StationCardLoader from '../common/StationCardLoader/index';
import LongPressKds from '@components/common/LongPressButton/LongPressKds';
import KdsTimePicker from '../common/KdsTimePicker/index';

const PrepFooter = ({
  filterData,
  footerSelection,
  setCurrentPage,
  i
}) => {
  return (
    <div
      id={i.name}
      key={i.name}
      // ref={ref}
      className={cn('col-2 row fs-12 fw-600 mx-1 rounded overflowX overflowYHidden align-items-center od-container-card-border od-container-card-background color-black h-90', styles.footerCard)}
      style={filterData?.[i.name] ? { background: "#C1D0FF" } : { background: "white" }}
      role="presentation"
      onClick={() => { footerSelection(i); setCurrentPage(0) }}
    >
      <div className="col-12 px-1 text-capitalize text-center  od-text-primary">{i.name.length > 8 ? i.name.substring(0, 8) + '..' : i.name}{'(' + (i.notSchedule + i.Schedule) + ')'}</div>
    </div>
  );
};

const renderModifier = modifiersObj =>
  (modifiersObj || []).map(modifier => (
    <div
      key={modifier.modifierId}
      className={modifier.price ? 'col-12 text-left p-0' : 'd-none'}
    >
      {`${modifier.quantity > 1 ? `- ${modifier.quantity} x ` : '- '} ${modifier.modifierName
        }`}
      {(modifier.note || modifier.comment) && (
        <div className="pl-2">{modifier.note || modifier.comment}</div>
      )}
      {modifier.modifiers && modifier.modifiers.length > 0 && (
        <div className="pl-2">{renderModifier(modifier.modifiers)}</div>
      )}
    </div>
  ));

const StationCard = ({
  check,
  bumpApiCall,
  prepStartAll,
  searchOverlay,
  convertUTCDateToLocalDate,
  setSelectedObjects,
  selectedObjects,
  bumpApiSelected,
  getTileHeight,
  getPrepCompletedTime,
  duplicateDeviceIds,
  handleDropClick,
  prioritizedItem,
  setPriorityItem,
  isPrioritize,
  getWarning,
  colorCoding,
  deviceInfo,
  handleTicketExpandView,
  currentPage,
  getTime,
  loading,
  lastActiveTime,
  setPdfUrl,
  generateHeaderColor,
  filterData,
  handleDragRushApiCall
}) => {

  // Changes in this component should also be made in ./stationCard.jsx

  const [isOpen, setIsOpen] = useState(false);

  const kdsSettings = deviceInfo?.deviceGroup?.kdsSettings;
  const orderTypeName = check?.checkHeader?.orderTypeName || '';
  const revenueCenterName = check?.checkHeader?.revenueCenterName || '';
  const columnCount = deviceInfo.columnCount;
  const innerWidth = window.innerWidth;
  const [headerColor, setHeaderColor] = useState('');
  const [isBumpConfirm, setBumpConfirmationModal] = useState(false);
  const [loaderId, setLoaderId] = useState('');
  const [dragRushModalData, setDragRushModalData] = useState({
    isOpen: false, data: {}, modalName: '', checkData: {},
    storeId: undefined, itemId: undefined, itemName: undefined,
  });
  const [dragRushInputTime, setDragRushInputTime] = useState({ isConformationPopUpOpen: false, hours: 0, mins: 0, seconds: 0 });


  useEffect(() => {
    if (loading === false) {
      setLoaderId('')
    }
  }, [loading])

  const [orderModeData, setOrderModeData] = useState({});

  let width = 33;
  if (columnCount) {
    width = 100 / columnCount;
  }
  const substringLength =
    width < 18
      ? Math.floor((width * 3) / orderTypeName.length)
      : width <= 20
        ? Math.floor((width * 5) / orderTypeName.length)
        : width < 33
          ? Math.floor((width * 5) / orderTypeName.length)
          : 10;
  const substringLengthTwo =
    width < 18
      ? Math.floor((width * 3) / orderTypeName.length)
      : width < 33
        ? Math.floor((width * 7) / orderTypeName.length)
        : 10;

  const subStringNameTwo = sentence => {
    return sentence.length !== sentence.substring(0, substringLengthTwo).length
      ? sentence.substring(0, substringLengthTwo) + sentence.length !== 0 ? '..' : ''
      : width > 18
        ? sentence
        : sentence.substring(0, 3);
  };
  const subStringName = sentence => {
    return sentence.length !== sentence.substring(0, substringLength).length
      ? sentence.substring(0, substringLength) + sentence.length !== 0 ? `${sentence?.substring(0, substringLength)}..` : ''
      : sentence;
  };

  // *****************

  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrollDownCount, setScrollDownCount] = useState(0);
  const [scrollUpCount, setScrollUpCount] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const { scrollHeight, clientHeight } = container;
    setScrollPosition(0);
    setScrollUpCount(0)
    const upScrollCount = (scrollHeight - clientHeight) / 100;
    setScrollDownCount(upScrollCount === 0 ? Math.ceil(upScrollCount) : Math.floor(upScrollCount) + 1);
  }, [containerRef.current, currentPage, isPrioritize, filterData]);

  useEffect(() => {
    setScrollPosition(0);
  }, [containerRef.current, isPrioritize]);

  const handleScrollUpButtonClick = () => {
    const container = containerRef.current;
    const newPosition = scrollPosition - 100;
    if (scrollPosition > 0) {
      container.scrollTo({ top: newPosition, behavior: "smooth" });
      setScrollPosition(newPosition);
      setScrollUpCount(scrollUpCount - 1);
      setScrollDownCount(scrollDownCount + 1);
    }
  };

  const handleScrollDownButtonClick = () => {
    const container = containerRef.current;
    if (scrollPosition + container.clientHeight < container.scrollHeight - 1) {
      const newPosition = scrollPosition + 100;
      container.scrollTo({ top: newPosition, behavior: "smooth" });
      setScrollPosition(newPosition);
      setScrollDownCount(scrollDownCount - 1);
      setScrollUpCount(scrollUpCount + 1)
    }
  };
  const handleScrolling = (e) => {
    const container = e.target;
    const { scrollTop, scrollHeight, clientHeight } = container;
    const upScrollCount = (scrollHeight - scrollTop - clientHeight) / 100;
    console.log({ scrollHeight, scrollTop, clientHeight, upScrollCount });
    setScrollDownCount(upScrollCount === 0 ? Math.ceil(upScrollCount) : Math.floor(upScrollCount) + 1);
    const totalCount = Math.ceil((scrollHeight - clientHeight) / 100);
    const updateUpCount = totalCount - scrollDownCount;
    setScrollUpCount(prevCount => (upScrollCount === 0 || upScrollCount === 0.01) ? totalCount : updateUpCount)
    const newPosition = scrollTop;
    setScrollPosition((prevPosition) => prevPosition + (newPosition - prevPosition))

  }
  // @@@@@@@@@@@@@@

  const bumpSelected = (check, checkPrepId) => {
    let items = [];
    for (let i = 0; i < selectedObjects[checkPrepId].length; i++) {
      const element = selectedObjects[checkPrepId][i];
      items.push({
        entityId: element.entityId,
        isModifier: element.isModifier,
      });
    }
    bumpApiSelected(check, 'expoSelectedBump', items);
    for (let i = 0; i < selectedObjects[checkPrepId].length; i++) {
      const element = selectedObjects[checkPrepId][i];
      setSelectedObjects(prevState => {
        return {
          ...prevState, // copy the previous state
          [checkPrepId]: prevState[checkPrepId].filter(
            obj => obj.entityId !== element.entityId
          ), // remove the object from the array with the corresponding id
        };
      });
    }
  };

  const handleCheckboxChange = (event, item, checkId) => {
    const selectedObject = { id: checkId }; // create a new object with an id property

    if (event.target.checked) {
      setSelectedObjects(prevState => {
        return {
          ...prevState, // copy the previous state
          [selectedObject.id]: [...(prevState[selectedObject.id] || []), item], // add the selected object to the array with the corresponding id
        };
      });
    } else {
      setSelectedObjects(prevState => {
        return {
          ...prevState, // copy the previous state
          [selectedObject.id]: prevState[selectedObject.id].filter(
            obj => obj.entityId !== item.entityId
          ), // remove the object from the array with the corresponding id
        };
      });
    }

    // log the selected objects array for debugging purposes
  };



  const customStatusColor = buildStatus => {
    return buildStatus === 2
      ? styles.bgGrey
      : buildStatus === 5
        ? styles.bgBlue
        : buildStatus === 8
          ? styles.bgSuccess
          : styles.textColor;
  };

  const individualItemSquire = (
    kdsStatus,
    plannedCompleteDate
  ) => {
    const currentTime = new Date().getTime();
    const plannedExpoCompleteDate = convertUTCDateToLocalDate(
      new Date(plannedCompleteDate)
    ).getTime();
    if (
      kdsStatus == 2 &&
      (!plannedExpoCompleteDate || currentTime <= plannedExpoCompleteDate)
    ) {
      return '#767676';
    } else if (kdsStatus == 2 && currentTime >= plannedExpoCompleteDate) {
      return '#767676';
    } else if (kdsStatus == 8) {
      return '#18BD63';
    } else if (kdsStatus == 5) {
      return '#0060FF';
    }
    return '#d1d1d1';
  };
  const onClose = () => {
    setIsOpen(false);
  };

  const checkBoxCheck = (data, id) => {
    if (data != undefined) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element.entityId === id) {
          return true;
        }
      }
    }
    return false;
  };

  const getSortData = data => {
    const obj = {};

    data.forEach(item => {
      let { seatId } = item;

      if (!kdsSettings?.groupBySeat) {
        seatId = 1234;
      }

      if (!obj[seatId]) {
        obj[seatId] = [];
      }

      obj[seatId].push(item);
    });

    for (let key in obj) {
      let allDayItems = obj[key].filter(val => {
        const momentTime = val.plannedStartDate && moment.utc(val.plannedStartDate).local();
        const currentTime = moment();
        return val.expoStatus != 8 && currentTime > momentTime;
      });

      allDayItems = allDayItems.sort((a, b) => {
        const timeA = new Date(a.plannedStartDate).getTime();
        const timeB = new Date(b.plannedStartDate).getTime();

        if (timeA === timeB) {
          // If timing is the same, sort based on name property
          return a.name.localeCompare(b.name);
        }

        return timeA - timeB;
      });

      let scheduledItems = obj[key].filter(val => {
        const momentTime = moment.utc(val.plannedStartDate).local();
        const currentTime = moment();
        return val.expoStatus != 8 && currentTime < momentTime;
      });

      scheduledItems = scheduledItems.sort((a, b) => {
        const timeA = new Date(a.plannedStartDate).getTime();
        const timeB = new Date(b.plannedStartDate).getTime();

        if (timeA === timeB) {
          // If timing is the same, sort based on name property
          return a.name.localeCompare(b.name);
        }

        return timeA - timeB;
      });

      let completedItems = obj[key].filter(val => val.expoStatus == 8)?.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      obj[key] = [...allDayItems, ...scheduledItems, ...completedItems];

    }

    return obj;
  };

  const handleBumbBtnClr = (type) => {
    return check && (check?.expoItems?.some((el) => { return el.expoStatus >= 5 }) && type !== 'prioritize')
  }

  const checkFooter = (type) => {
    return (<>
      <div className='col-5 p-0 d-flex color-white'>
        <div role='button' className='d-flex flex-column align-items-center w-35' style={{ background: scrollDownCount === 0 ? "#C6C6C6" : '#6A4DAE', padding: '5px' }} onClick={scrollDownCount > 0 ? handleScrollDownButtonClick : undefined}>
          <span>{scrollDownCount}</span>
          <img src={downArrow} alt="scroll down" width="12px" />
        </div>
        <div role='button' className='d-flex flex-column align-items-center w-35' onClick={scrollUpCount > 0 ? handleScrollUpButtonClick : undefined} style={{ background: scrollUpCount === 0 ? "#C6C6C6" : '#6A4DAE', padding: '5px' }}>
          <span>{scrollUpCount}</span>
          <img src={upArrow} alt="scroll up" width="12px" />
        </div>
        <div className='d-flex flex-column align-items-center w-20 justify-content-center pl-3'>
          {check.rePrioritized && (
            <img className='d-flex justify-content-center' src={prioritizeIcon} width="20px" alt="prioritize" />
          )}
          {
            check?.receivedDate > lastActiveTime && <img className='d-flex justify-content-center' src={NewIcon} width="20px" alt="new-icon" />
          }
          {
            check?.checkedIn && (
              <img className='d-flex justify-content-center' src={checkedInIcon} width="20px" alt="checked" />
            )
          }
        </div>
      </div>
      <div className='col-2 p-0 d-flex justify-content-center' role="button" onClick={() => handleTicketExpandView(check, headerColor)}>
        <img src={expand} alt="expand items" width="20px" />
      </div>
      <div className={cn('d-flex align-items-center justify-content-center p-0', type === 'drop' ? 'col-12' : 'col-5', type === 'drop' && styles.move_here)} style={{ backgroundColor: type === 'drop' ? '#0060FF' : handleBumbBtnClr(type) ? '#0060FF' : '#71B2FF', color: 'white', zIndex: 1 }}
        onClick={() => {
          switch (type) {
            case 'prioritize': setPriorityItem({ ...prioritizedItem, selectedItemId: check.id });
              break;
            case 'drop': handleDropClick(check.id);
              break;
            default: checkPendingItems() ? (setBumpConfirmationModal(true), setLoaderId(check?.id)) : selectedObjects?.hasOwnProperty(check.id + '') && selectedObjects[check.id]?.length > 0 ? (bumpSelected(check, check.id + ''), setLoaderId(check?.id)) : (bumpApiCall(check, 'expo'), setLoaderId(check?.id));
              break;
          }
        }}
      >
        {selectedObjects?.hasOwnProperty(check.id + '') &&
          selectedObjects[check.id].length > 0 && <img src={checkBoxIcon} alt="bump selected" width="20px" />}
        {type === 'prioritize' ? LABEL().KDS_PRIORITIZE :
          type === 'drop' ?
            <div className={cn('fs-12')}>
              <img src={placeIcon} alt="drop item" width="25px" />
              {LABEL().KDS_MOVE_HERE}
            </div>
            : LABEL().KDS_BUMP}
      </div>
    </>)
  }

  const renderItemModifiers = (item, modPadding) => {
    const modifiers = item?.modifiers?.map((modifierItem, modifierIndex) => {
      return (
        <div key={modifierItem.name + modifierIndex} className={`row mx-0 w-100 ${modifierIndex < item.length - 1 ? 'pb-2' : ''}`} style={{ fontSize: 'max(1.1vw, 1.1vh)', }}>
          <div className={cn(columnCount <= 4 ? "w-10" : "w-13")}>
            {(modifierItem.prepStatus != 0 || modifierItem.buildStatus != 0) &&
              <input type='checkbox' style={{ width: columnCount <= 4 && '100%' }} className={cn('', styles.checkbox)} onChange={(event) => handleCheckboxChange(event, modifierItem, check.id)} checked={checkBoxCheck(selectedObjects[check.id], modifierItem?.entityId)} disabled={modifierItem.expoStatus === 8} />
            }
          </div>
          {(modifierItem?.buildStatus != 0) ?
            <LongPressKds
              className={cn("col-6 text-left", kdsStyles.modifiers)}
              style={{ overflowY: 'scroll', whiteSpace: "nowrap", paddingLeft: modPadding + 'px', textDecoration: modifierItem.expoStatus === 8 ? "line-through" : '', textDecorationColor: 'red', color: modifierItem?.allergy ? 'red' : (getTime(modifierItem.plannedStartDate) ? 'black' : 'gray') }}
              onLongPress={() => handleLongPress(check?.storeId, modifierItem?.itemId, modifierItem?.name, true, modifierItem, check)}
              onClick={() => { }}
            >
              - {modifierItem?.quantity > 1 ? modifierItem?.quantity + 'x' : ''}&nbsp; {modifierItem.name}
              <div className="text-left pl-2" style={{ color: '#CE842A', fontSize: 'max(1.1vw, 1.1vh)' }}>
                {`${modifierItem.comment ? `- ${modifierItem.comment}` : ''}`}
              </div>
            </LongPressKds> :
            <LongPressKds
              className={cn("col-6 text-left", kdsStyles.modifiers)}
              style={{ overflowY: 'scroll', whiteSpace: "nowrap", paddingLeft: modPadding + 'px', textDecoration: modifierItem?.expoStatus === 8 ? 'line-through' : '', textDecorationColor: 'red', color: modifierItem?.allergy ? 'red' : (getTime(modifierItem.plannedStartDate) ? 'black' : 'gray') }}
              onLongPress={() => handleLongPress(check?.storeId, modifierItem?.itemId, modifierItem?.name, true, modifierItem, check)}
              onClick={() => { }}
            >
              - {modifierItem?.quantity > 1 ? modifierItem?.quantity + 'x' : ''}&nbsp; {modifierItem.name}
              <div className="text-left pl-2" style={{ fontSize: 'max(1.1vw, 1.1vh)', color: '#CE842A' }}>
                {`${modifierItem?.comment ? `- ${modifierItem?.comment}` : ''}`}
              </div>
            </LongPressKds>
          }
          {(modifierItem.plannedStartDate || modifierItem.plannedBuildStartDate) ?
            <div className="col-md px-1 text-right d-flex justify-content-end align-items-center">
              {getWarning(modifierItem) && colorCoding(modifierItem) && <div className='pr-1'>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 21 19" fill={colorCoding(modifierItem)}>
                  <path d="M10.3924 13.3518C9.81129 13.3518 9.32422 13.8389 9.32422 14.4199C9.32422 15.001 9.81129 15.4881 10.3924 15.4881C10.9521 15.4881 11.4605 15.001 11.4349 14.4456C11.4605 13.8346 10.9777 13.3518 10.3924 13.3518Z" />
                  <path d="M20.2786 17.1372C20.9494 15.9793 20.9536 14.5993 20.2871 13.4457L13.5963 1.85856C12.9341 0.692152 11.7378 0 10.3962 0C9.05461 0 7.8583 0.696424 7.19605 1.85428L0.496704 13.4542C-0.169813 14.6206 -0.165541 16.0092 0.509521 17.1671C1.17604 18.3121 2.36808 19 3.70111 19H17.0656C18.4029 19 19.6035 18.3036 20.2786 17.1372ZM18.8259 16.2998C18.4542 16.9406 17.7962 17.3209 17.0614 17.3209H3.69684C2.97051 17.3209 2.31681 16.9492 1.95364 16.3211C1.5862 15.6845 1.58193 14.924 1.94937 14.2831L8.64872 2.68743C9.01188 2.05082 9.66131 1.67484 10.3962 1.67484C11.1268 1.67484 11.7805 2.05509 12.1437 2.6917L18.8387 14.2874C19.1976 14.9112 19.1934 15.6631 18.8259 16.2998Z" />
                  <path d="M10.1264 5.8534C9.61793 5.99866 9.30176 6.4601 9.30176 7.0198C9.32739 7.35733 9.34876 7.69914 9.37439 8.03667C9.44702 9.3227 9.51966 10.5831 9.59229 11.8691C9.61793 12.3049 9.95546 12.6211 10.3913 12.6211C10.8271 12.6211 11.1689 12.2836 11.1902 11.8435C11.1902 11.5786 11.1902 11.3351 11.2159 11.0659C11.2629 10.2413 11.3141 9.4167 11.3611 8.5921C11.3868 8.05803 11.4338 7.52396 11.4594 6.98989C11.4594 6.79763 11.4338 6.62673 11.3611 6.45583C11.1432 5.9773 10.6348 5.73377 10.1264 5.8534Z" />
                </svg>
              </div>}
              <i className={cn(`fa fa-circle fs-12 fa-rotate-180`)} style={{ color: individualItemSquire(modifierItem.prepStatus, check.startDate, check.plannedStartDate) }} aria-hidden="true" />
              <div className='h-100' style={{ width: "1.5px" }} />
              <i className={cn(`fa fa-circle fs-12 ${customStatusColor(modifierItem.buildStatus)}`)} aria-hidden="true" />
              <span className="ml-1 text-dark">{modifierItem.prepStatus != 8 ? <ExpoTime date={modifierItem.plannedStartDate} /> : getPrepCompletedTime(modifierItem)}</span>
            </div> : <div className='col-3'></div>}
          {modifierItem?.modifiers && modifierItem.modifiers.length > 0 && renderItemModifiers(modifierItem, modPadding + 10)}
        </div>
      )
    });
    return modifiers;
  }

  const checkPendingItems = () => {
    const expoItems = selectedObjects[check.id]?.length > 0 ? selectedObjects[check.id] : check.expoItems;
    let isPending = false;
    expoItems.forEach((item) => {
      if ((item.prepStatus > 0 && item.prepStatus < 8) || (item.buildStatus > 0 && item.buildStatus < 8)) {
        isPending = true;
        return;
      }
    })
    return isPending;
  }

  const getheaderColor = (items, headerColorId) => {
    items.forEach(item => {
      if (item.warningColorId > headerColorId) {
        headerColorId = item.warningColorId;
      }
      if (headerColorId === 4) return headerColorId;
      if (item?.modifiers.length > 0) {
        headerColorId = getheaderColor(item.modifiers, headerColorId);
        if (headerColorId === 4) return headerColorId;
      }
    });
    return headerColorId;
  }


  const rendercheckItems = (items, isModifier) => {
    let hasNewItem = false;
    const itemData = items?.map(item => {
      let modData = [];
      if (item?.modifiers.length > 0) modData = rendercheckItems(item.modifiers, true);
      let warningColorId = !getTime(item.plannedStartDate) ? 0 : item.prepStatus == 0 && item.buildStatus == 0 ? isModifier ? 0 : 1 : getWarning(item) ? colorCoding(item) : 1;
      warningColorId = (!warningColorId && warningColorId !== 0) || warningColorId === 'black' ? 1 : warningColorId === 'yellow' ? 2 : warningColorId === '#F49F40' ? 3 : warningColorId === '#FF6464' ? 4 : warningColorId;
      if (!isModifier) {
        if (!hasNewItem && warningColorId === 1 && item.expoStatus < 5) {
          hasNewItem = true;
        }
      }
      return { ...item, modifiers: modData, warningColorId }
    });
    if (!isModifier) setHasNewItem(hasNewItem);
    return itemData;
  }

  const handleLongPress = (storeId, itemId, itemName, isModifier, item, check) => {
    setOrderModeData({ isOpenn: true, isPdfOpen: false, storeId: storeId, itemId: itemId, itemName: itemName, isModifier: isModifier || false });

    setDragRushModalData({
      isOpen: false,
      prepStatus: item?.prepStatus,
      storeId: storeId, itemId: itemId, itemName: itemName,
      data: item,
      checkData: {
        checkHeaderId: check?.checkHeader?.id,
        checkPrepId: check?.id,
        employeeId: check?.checkHeader?.employeeId,
      }
    })
  };

  const onCloseLongPress = () => {
    setOrderModeData({ isOpenn: false });
    setPdfUrl([])
  }

  useEffect(() => {
    let defaultColor = generateHeaderColor(check)
    setHeaderColor(defaultColor);
  }, [check]);

  const getPickupTime = (time) => {
    if (time) {
      const utcTime = moment.utc(time).local().format("h:mm A")
      return utcTime;
    }
    return time
  }

  const generateDragRushModalTime = () => {
    const data = dragRushModalData?.data
    if (data) {
      const prepStatus = data?.prepStatus;
      const buildStatus = data?.buildStatus;

      if (dragRushModalData?.modalName === LABEL().KDS_DRAG) {
        if ((prepStatus === 2 || prepStatus === 5) && (data?.prepStartDate || data?.plannedPrepStartDate)) {
          return moment.utc(data?.prepStartDate || data?.plannedPrepStartDate).local().format('hh:mm A');
        }
        if ((buildStatus === 2 || buildStatus === 5) && (data?.buildStartDate || data?.plannedBuildStartDate)) {
          return moment.utc(data?.buildStartDate || data?.plannedBuildStartDate).local().format('hh:mm A');
        }
      }
      if (dragRushModalData?.modalName === LABEL().KDS_RUSH) {
        if ((prepStatus === 2) && convertUTCDateToLocalDate(new Date(data?.plannedPrepStartDate)).getTime() > (new Date().getTime())) {
          return moment.utc(data?.plannedPrepStartDate).local().format('hh:mm A');
        }
        else {
          if (buildStatus === 2 && convertUTCDateToLocalDate(new Date(data?.plannedBuildStartDate)).getTime() > (new Date().getTime())) {
            return moment.utc(data?.plannedBuildStartDate).local().format('hh:mm A');
          }
        }
      }

    }
    return false;
  }

  const checkIsDragRushModal = (modalName) => {
    return dragRushModalData?.modalName === modalName;
  }

  return (
    <div
      id={check?.checkHeader?.id}
      data-cards={check?.checkHeader?.id}
      key={check?.checkHeader?.id}
      className={cn('h-100 w-100', searchOverlay ? styles.opacity : '', styles.p3)}
    >
      <div
        className={cn(
          'h-100 od-container-card-border od-container-card-background',
          styles.backgroundColor,
          styles?.expoStationCards
        )}
        style={{ border: `2px solid ${duplicateDeviceIds[check?.expoDeviceId]}` }}
      >
        {
          loading && (loaderId === check?.id) && <StationCardLoader />
        }
        <div
          className={cn(
            'w-100 fw-600 text-break text-uppercase d-flex mx-0 align-items-stretch justify-content-around color-black', columnCount > 5 ? 'py-2' : 'p-2',
          )}
          style={{ background: headerColor, padding: columnCount > 5 && '0.7px' }}
        >
          <div
            className={cn(
              'col-3 d-flex flex-column justify-content-center p-0 rounded od-text-secondary',
            )}
            style={{ fontSize: columnCount >= 5 ? 'max(1.1vw, 1.1vh)' : 'max(1.3vw, 1.3vh)' }}
          >
            {check?.checkHeader?.name?.length > 4 ? (
              <Tooltip innerWidth={innerWidth} text={check?.checkHeader?.name}>
                {check?.checkHeader?.tab === true ? (
                  check?.checkHeader?.name?.length < 4 ? (
                    check?.checkHeader?.name
                  ) : (
                    <span> {check?.checkHeader?.name?.substring(0, 4)}..</span>
                  )
                ) : check?.checkHeader?.stationNumber?.length < 4 ? (
                  check?.checkHeader?.stationNumber
                ) : (
                  <span>
                    {check?.checkHeader?.stationNumber?.substring(0, 4)}..
                  </span>
                )}
              </Tooltip>
            ) : (
              <>
                {check?.checkHeader?.tab === true ? (
                  check?.checkHeader?.name?.length < 4 ? (
                    check?.checkHeader?.name
                  ) : (
                    <span> {check?.checkHeader?.name?.substring(0, 4)}</span>
                  )
                ) : check?.checkHeader?.stationNumber?.length < 4 ? (
                  check?.checkHeader?.stationNumber
                ) : (
                  <span>
                    {' '}
                    {check?.checkHeader?.stationNumber?.substring(0, 4)}..
                  </span>
                )}{' '}
              </>
            )}
            <div>{`#${check?.checkHeader?.number}`}</div>
          </div>
          {(!kdsSettings?.displayOrderType &&
            !kdsSettings?.displayRevenueCenter) ||
            (kdsSettings?.displayOrderType && kdsSettings?.displayRevenueCenter) ||
            deviceInfo.deviceGroup === null ? (
              <div
                className={cn(
                  'align-items-center justify-content-center fw-100 od-text-secondary d-flex flex-column'
                )}
                style={{
                  fontSize: columnCount >= 5 ? 'max(1vw, 1vh)' : 'max(1.3vw, 1.3vh)',
                }}
              >
                {
                  kdsSettings?.displayOrderType && (
                    <div style={{ fontWeight: 'bold' }}>
                      <span>{subStringName(orderTypeName)}</span>
                    </div>
                  )
                }
                {
                  kdsSettings?.displayRevenueCenter && (
                    <div style={{ fontWeight: 'bold' }}>
                      <span>{subStringName(revenueCenterName)}</span>
                    </div>
                  )
                }
              </div>
          ) : kdsSettings?.displayOrderType ? (
            <div
              className={cn(
                'col-4 d-flex align-items-center justify-content-center px-0 fw-100 od-text-secondary',
                'fs-12'
              )}
            >
              {subStringNameTwo(orderTypeName)}
            </div>
          ) : (
            <div
              className={cn('col-4 p-0 d-flex align-items-center justify-content-center px-0 fw-100 od-text-secondary fs-12')}
              style={{ fontWeight: 'bold' }}
            >
              {subStringNameTwo(revenueCenterName)}
            </div>
          )}
          <div className="col-4 p-0 d-flex flex-column align-items-end justify-content-around od-text-secondary">
            <div
              className={cn(
                'px-0 text-left',
              )}
              style={{ fontSize: columnCount >= 5 ? 'max(1.1vw, 1.1vh)' : 'max(1.3vw, 1.3vh)' }}
            >{check?.checkHeader.employeeFirstName && check?.checkHeader?.employeeLastName && `${check?.checkHeader?.employeeFirstName.split(' ')[0].length < 4
              ? check?.checkHeader?.employeeFirstName?.split(' ')[0] + ' ' +
              check?.checkHeader?.employeeLastName?.substring(0, 4) + '..'
              : check.checkHeader?.employeeFirstName?.split(' ')[0]?.substring(0, 4) + '..'
              }`}</div>
            <div style={{ fontSize: columnCount >= 5 ? 'max(1.1vw, 1.1vh)' : 'max(1.3vw, 1.3vh)' }}>
              <ExpoTime date={check?.plannedStartDate} />
            </div>
          </div>
        </div>
        <div
          className={cn(`fs-12 overflowY Od-container-card-background`)}
          ref={containerRef}
          style={{
            maxHeight:
              getTileHeight(check),
            minHeight:
              getTileHeight(check),
          }}
          onScroll={(e) => handleScrolling(e)}
        >
          {Object.values(getSortData(check.expoItems))?.map((el) => {
            return (
              <>
                {kdsSettings?.groupBySeat && el[0]?.seatNumber &&
                  <div className='w-100 text-center fw-500' style={{ backgroundColor: '#FFFADD', border: kdsSettings?.groupBySeat && '2px solid #BEB893', fontSize: '10px' }}>
                    <span>
                      Seat {el[0]?.seatNumber}
                    </span>
                    {
                      el[0]?.seatName && (
                        <span className='ml-1'>
                          ({el[0]?.seatName?.length > 15 ? el[0]?.seatName?.substring(0, 15) + '..' : el[0]?.seatName})
                        </span>
                      )
                    }
                  </div>
                }
                <>
                  {
                    el?.map((item, index) => {

                      return (
                        <div key={`${item.id}-${index}`} className={cn('row mx-0 w-100 od-container-card-background pl-1 pr-1', styles.p3)} style={{ borderBottom: index < check.expoItems.length - 1 ? '1px solid #C9C9C9' : '', paddingTop: '7px' }}>
                          <div className={cn(columnCount <= 4 ? "w-10" : "w-13")}>
                           <input
                              type="checkbox"
                              style={{ width: columnCount <= 4 && '100%' }}
                              className={cn('', styles.checkbox)}
                              onChange={event =>
                                handleCheckboxChange(event, item, check.id)
                              }
                              checked={checkBoxCheck(
                                selectedObjects[check.id],
                                item.entityId
                              )}
                              disabled={item?.expoStatus === 8}
                            />
                          </div>
                          <LongPressKds className={cn("col-6 px-1 pb-1", kdsStyles.item)}
                            style={{
                              textDecoration:
                                item?.expoStatus === 8 ? 'line-through' : '',
                              textDecorationColor: 'red',
                              color: item.allergy ? 'red' : getTime(item?.plannedStartDate) ? 'black' : 'gray',
                            }}
                            onLongPress={() => { handleLongPress(check.storeId, item?.itemId, item?.name, false, item, check) }}
                            onClick={() => { }}
                          >
                            <div>

                              <div style={{
                                textDecoration: item?.expoStatus === 8 ? 'line-through' : '',
                                textDecorationColor: 'black',
                                color: item.allergy ? 'red' : getTime(item?.plannedStartDate) ? 'black' : 'gray',
                              }}
                              >
                                {item?.quantity > 1 ? item?.quantity + 'x' : '1x'}&nbsp;{item.name}
                              </div>
                              {
                                item?.comment && (
                                  <div
                                    className="text-left fs-12 pl-2"
                                    style={{ color: '#CE842A' }}
                                  >
                                    {`${item.comment ? `- ${item.comment}` : ''}`}
                                  </div>
                                )
                              }
                            </div>
                          </LongPressKds>
                          <Modal isOpen={orderModeData?.isOpenn} customClass={'position-absolute p-2 px-3'} style={{ border: '0px', backgroundColor: '#FFFFFF', height: window?.innerWidth < 1000 ? '10rem' : '15rem', borderRadius: '0px' }}>
                            <div className='d-flex justify-content-between p-2 px-3 mb-2'>
                              <div className={cn(kdsStyles.item, 'text-dark')} style={{ fontWeight: '800', fontSize: columnCount <= 4 ? 'Max(1.7vw, 1.7vh)' : '' }}>
                                {orderModeData?.itemName}
                              </div>
                              <div style={{ color: 'black', position: 'absolute', right: '7px', top: '-2px' }}>
                                <i role='button' className="fa fa-times fs-30" onClick={() => onCloseLongPress()} />
                              </div>
                            </div>
                            <div className='pt-1' role='button'
                              onClick={() => {
                                setDragRushModalData((prev) => ({ ...prev, isOpen: true, modalName: LABEL().KDS_DRAG }));
                                setOrderModeData({ isOpenn: false, isPdfOpen: true, itemName: '' });
                              }}
                            >
                              <span className='p-2 pl-3'> <img src={kdsDragIcon} alt="pdf" /> </span>
                              <span className='text-dark' style={{ fontSize: columnCount <= 4 ? 'Max(1.5vw, 1.5vh)' : '' }}> {LABEL().KDS_DRAG} </span>
                            </div>
                            <div className='pt-1' role='button'
                              onClick={() => {
                                setDragRushModalData((prev) => ({ ...prev, isOpen: true, modalName: LABEL().KDS_RUSH }))
                                setOrderModeData({ isOpenn: false, isPdfOpen: true, itemName: '' })
                              }}
                            >
                              <span className='p-2 pl-3'> <img src={kdsRushIcon} alt="pdf" /> </span>
                              <span className='text-dark' style={{ fontSize: columnCount <= 4 ? 'Max(1.5vw, 1.5vh)' : '' }}> {LABEL().KDS_RUSH} </span>
                            </div>
                          </Modal>
                          <Modal
                            isOpen={dragRushModalData?.isOpen}
                            isModalCenter
                            customClass2={'w-60 fw-600 fs-20'}
                            style={{
                              minHeight: checkIsDragRushModal(LABEL().KDS_RUSH) ? '45vh' : '65vh',
                              backgroundColor: '#FFFFFF',
                              justifyContent: 'space-between',
                            }}
                          >
                            <div
                              className='d-flex justify-content-between align-items-center py-2 px-3'
                              style={{ backgroundColor: '#D8D8D8', color: '#4A4A4A' }}
                            >
                              <div className='d-flex align-items-center' style={{ fontWeight: '400', fontSize: '32px' }}>
                                <span className='pr-3'>
                                  <img style={{ width: '44px', height: '44px' }} alt="drag-rush"
                                    src={checkIsDragRushModal(LABEL().KDS_DRAG) ? kdsDragIcon : kdsRushIcon}
                                  />
                                </span>
                                {dragRushModalData?.modalName}
                              </div>
                              <div className='w-10 d-flex justify-content-end'>
                                <i className="fa fa-times fs-30"
                                  role='button'
                                  onClick={() => {
                                    setDragRushModalData({
                                      isOpen: false, data: {}, modalName: '', checkData: {},
                                      storeId: undefined, itemId: undefined, itemName: undefined,
                                    })
                                    setDragRushInputTime({ isConformationPopUpOpen: false, mins: 0 })
                                  }}
                                />
                              </div>
                            </div>
                            <div className='d-flex justify-content-between px-4 fs-20' style={{ color: '#4A4A4A' }}>
                              <div>
                                {dragRushModalData?.itemName}
                              </div>
                              <div
                                className={cn('d-flex',
                                  checkIsDragRushModal(LABEL().KDS_RUSH) && generateDragRushModalTime() && 'w-40 justify-content-between'
                                )}
                              >
                                {
                                  checkIsDragRushModal(LABEL().KDS_RUSH) && (
                                    <div>
                                      <ExpoTime date={dragRushModalData?.data?.plannedStartDate} />
                                    </div>
                                  )
                                }
                                <div>
                                  {generateDragRushModalTime()}
                                </div>
                              </div>
                            </div>
                            {
                              dragRushModalData?.modalName === LABEL().KDS_DRAG && <div className='py-1' style={{ color: '#4A4A4A', }}>
                                <KdsTimePicker setTime={setDragRushInputTime} time={dragRushInputTime} format={'mm'} disableAll={!generateDragRushModalTime()} />
                              </div>
                            }
                            <div className='d-flex justify-content-end' style={{ color: '#4A4A4A' }}>
                              <div className='w-30 d-flex justify-content-end'>
                                <button className='rounded btn-ripple p-2 w-90 my-3'
                                  style={{ backgroundColor: '#FFF', borderColor: '#0060FF', color: '#0060FF' }}
                                  onClick={() => {
                                    setDragRushModalData({
                                      isOpen: false, data: {}, modalName: '', checkData: {},
                                      storeId: undefined, itemId: undefined, itemName: undefined,
                                    })
                                    setDragRushInputTime({ isConformationPopUpOpen: false, mins: 0 })
                                  }}
                                >
                                  {LABEL().CANCEL}
                                </button>
                              </div>
                              <div className='w-30 d-flex justify-content-center'>
                                <button className='rounded od-btn-primary color-white btn-ripple p-2 w-90 m-3'
                                  style={{
                                    border: 'none',
                                    backgroundColor: (dragRushModalData?.modalName === LABEL().KDS_DRAG && (generateDragRushModalTime() ?
                                      ((dragRushInputTime?.mins === 0 || dragRushInputTime?.mins == "") ? '#7B7B7B' : '#0060FF')
                                      : '#7B7B7B')) || (generateDragRushModalTime() ? '#0060FF' : '#7B7B7B')
                                  }}
                                  disabled={
                                    (dragRushModalData?.modalName === LABEL().KDS_DRAG &&
                                      (!generateDragRushModalTime() || dragRushInputTime?.mins === 0 || dragRushInputTime?.mins === "")) ||
                                    (dragRushModalData?.modalName == LABEL().KDS_RUSH && !generateDragRushModalTime())
                                  }
                                  onClick={() => { setDragRushInputTime(prev => ({ ...prev, isConformationPopUpOpen: true })) }}
                                >
                                  {LABEL().SUBMIT}
                                </button>
                              </div>
                            </div>
                          </Modal>
                          <Modal
                            isOpen={dragRushInputTime?.isConformationPopUpOpen}
                            isModalCenter customClass2={styles.bumpModalMaxWidth}
                          >
                            <div className={cn(styles.bumpConfirmationModal, 'fs-20 fw-400')}>
                              <div className="px-2 py-2 text-right w-100">
                                <i className="fa fa-times fs-30"
                                  role='button'
                                  style={{ color: '#4A4A4A' }}
                                  onClick={() => setDragRushInputTime(prev => ({ ...prev, isConformationPopUpOpen: false }))}
                                />
                              </div>
                              <div className={cn('text-center text-dark mb-3 ml-5 mr-5')}>
                                <p>
                                  {
                                    dragRushModalData?.modalName === LABEL().KDS_DRAG ? CUSTOM_MESSAGES().KDS_DRAG_CONFIRMATION : CUSTOM_MESSAGES().KDS_RUSH_CONFORMATION
                                  }
                                </p>
                                <div>
                                  <button
                                    className={cn('rounded od-btn-primary color-dark btn-ripple w-40 m-3 border-dark h-10 p-2')}
                                    style={{ border: '1px solid black' }}
                                    onClick={() => setDragRushInputTime(prev => ({ ...prev, isConformationPopUpOpen: false }))}
                                  >
                                    {LABEL().NO}
                                  </button>
                                  <button
                                    style={{ border: '1px solid #0060FF' }}
                                    className={cn('rounded od-btn-primary color-white btn-ripple w-40 m-3 h-10 p-2', styles.popUpBtnColor)}
                                    onClick={() => handleDragRushApiCall(dragRushModalData, dragRushInputTime, setDragRushInputTime, setDragRushModalData)}
                                  >
                                    {LABEL().YES}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </Modal>
                          <div
                            className="col-md px-1 text-right d-flex justify-content-end align-items-center"
                            style={{ fontSize: 'max(1.1vw, 1.1vh)' }}
                          >
                            {item?.expoStatus !== 0 && (item?.expoStatus == 5 || getTime(item.plannedStartDate)) ? (
                              <>
                                {getWarning(item) && colorCoding(item, check?.startDate, check?.plannedExpoStartDate) && <div className='pr-1'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 21 19" fill={colorCoding(item, check?.startDate, check?.plannedExpoStartDate)}>
                                    <path d="M10.3924 13.3518C9.81129 13.3518 9.32422 13.8389 9.32422 14.4199C9.32422 15.001 9.81129 15.4881 10.3924 15.4881C10.9521 15.4881 11.4605 15.001 11.4349 14.4456C11.4605 13.8346 10.9777 13.3518 10.3924 13.3518Z" />
                                    <path d="M20.2786 17.1372C20.9494 15.9793 20.9536 14.5993 20.2871 13.4457L13.5963 1.85856C12.9341 0.692152 11.7378 0 10.3962 0C9.05461 0 7.8583 0.696424 7.19605 1.85428L0.496704 13.4542C-0.169813 14.6206 -0.165541 16.0092 0.509521 17.1671C1.17604 18.3121 2.36808 19 3.70111 19H17.0656C18.4029 19 19.6035 18.3036 20.2786 17.1372ZM18.8259 16.2998C18.4542 16.9406 17.7962 17.3209 17.0614 17.3209H3.69684C2.97051 17.3209 2.31681 16.9492 1.95364 16.3211C1.5862 15.6845 1.58193 14.924 1.94937 14.2831L8.64872 2.68743C9.01188 2.05082 9.66131 1.67484 10.3962 1.67484C11.1268 1.67484 11.7805 2.05509 12.1437 2.6917L18.8387 14.2874C19.1976 14.9112 19.1934 15.6631 18.8259 16.2998Z" />
                                    <path d="M10.1264 5.8534C9.61793 5.99866 9.30176 6.4601 9.30176 7.0198C9.32739 7.35733 9.34876 7.69914 9.37439 8.03667C9.44702 9.3227 9.51966 10.5831 9.59229 11.8691C9.61793 12.3049 9.95546 12.6211 10.3913 12.6211C10.8271 12.6211 11.1689 12.2836 11.1902 11.8435C11.1902 11.5786 11.1902 11.3351 11.2159 11.0659C11.2629 10.2413 11.3141 9.4167 11.3611 8.5921C11.3868 8.05803 11.4338 7.52396 11.4594 6.98989C11.4594 6.79763 11.4338 6.62673 11.3611 6.45583C11.1432 5.9773 10.6348 5.73377 10.1264 5.8534Z" />
                                  </svg>
                                </div>}
                                <i className={cn(`fa fa-circle fs-12 fa-rotate-180`)} style={{ color: individualItemSquire(item?.prepStatus, check.startDate, check.plannedStartDate) }} aria-hidden="true" />
                                <div className='h-100' style={{ width: "1.5px" }}></div>
                                <i className={cn(`fa fa-circle fs-12 ${customStatusColor(item.buildStatus)}`)} aria-hidden="true" />
                              </>
                            ) : (
                              <div
                                className={cn('box align-item-center ')}
                                style={{
                                  height: '1rem',
                                  width: '13px',
                                  marginRight: '0.6rem',
                                  marginBottom: '0.1rem',
                                }}
                              >
                                {item?.expoStatus == 8 || (item?.prepStatus == 0 && item?.buildStatus == 0) ? (
                                  <></>
                                ) : (
                                  <i
                                    className="fa fa-clock"
                                    style={{ color: 'black', fontSize: '0.9rem' }}
                                  ></i>
                                )}
                              </div>
                            )}
                            <div className='ml-1' style={{ color: 'black' }}><ExpoTime date={item.plannedStartDate} /></div>
                          </div>
                          {item?.modifiers && item?.modifiers.length > 0 && renderItemModifiers(item, 15)}
                        </div>
                      );
                    })
                  }
                </>
              </>
            )
          })}
        </div>

        <div className='row mx-0 w-100 text-center align-content-end position-absolute' style={{
          bottom: '0%',
          cursor: 'pointer',
          background: '#D9D9D9'
        }}>
          {
            check?.doNotMake && (
              <div className='w-100 d-flex align-items-center justify-content-center' style={{ backgroundColor: '#FF5959', border: '2px solid #9E4444', fontSize: '10px' }}>
                <div className='w-auto text-white px-2'>DO NOT MAKE</div>
              </div>
            )
          }
          {
            check?.hasAllergy && (
              <div className='w-100 d-flex align-items-center' style={{ backgroundColor: '#F2F2F2', border: '2px solid #CCC', fontSize: '10px' }}>
                <div className='w-auto text-white px-2' style={{ backgroundColor: 'red' }}>Allergy</div>
                <div className='w-80 text-left pl-2'>{check?.allergyText &&
                  (check.allergyText?.length > 25 ? check.allergyText?.substring(0, 25) + '..' : check?.allergyText)
                }
                </div>
              </div>
            )
          }
          {
            check?.offPremise ? (
              <div className='w-100' style={{ backgroundColor: '#E7EEF3', border: '2px solid #98AAB8', fontSize: '10px' }}>
                <div className='d-flex justify-content-between'>
                  <div className='pl-1' style={{ color: check?.checkedIn && 'red' }}>
                    <span>{check?.checkInNote || ''}</span>
                    {check?.vehicleInfo && <span className='ml-2'>{check?.vehicleInfo}</span>}
                  </div>
                  <div className='pr-1'>{check?.pickupTime && getPickupTime(check?.pickupTime) || ''}</div>
                </div>
                <div className='d-flex justify-content-between'>
                  <div className='pl-1'>
                    {check?.marketplace ? check?.marketplaceVendorName : check?.delivery ? 'Delivery' : 'Pickup'}
                  </div>
                  <div className='pr-1' style={{ color: '#EA6262' }}>{check?.pickupTime && <ExpoTime date={check?.pickupTime} />}</div>
                </div>
              </div>
            ) :
              (<>
                <div className='w-100 text-center fw-500' style={{ backgroundColor: '#FFFADD', border: check?.courseName && '2px solid #BEB893', fontSize: '10px' }}>
                  {check?.courseName}
                </div>
                {
                  check?.checkedIn && (
                    <div className='w-100 text-left pl-1 fw-500' style={{ backgroundColor: '#E7EEF3', border: check?.courseName && '2px solid #98AAB8', fontSize: '10px', color: 'red' }}>
                      {check?.checkInNote || ''}
                    </div>
                  )
                }
              </>
              )
          }
          {isPrioritize ? (!prioritizedItem.selectedItemId ? checkFooter('prioritize') :
            prioritizedItem.selectedItemId === check.id ?
              <div role='button' className={cn('d-flex justify-content-center align-content-center w-100', styles.prioritize)} onClick={() => setPriorityItem({ selectedItemId: null, dropItemId: null })}>
                <img src={checkIcon} alt="prioritize icon" width="30px" />
                <span className='d-flex align-items-center'>{LABEL().KDS_SELECTED}</span>
              </div> : checkFooter('drop'))
            : checkFooter('')
          }
        </div>

        <Modal isOpen={isOpen} isModalCenter customClass2={styles.maxWidth} customClass3={styles.rad}>
          <div style={{ backgroundColor: '#FFFFFF' }}>
            <div className="px-2 py-2 text-right">
              <i
                role="presentation"
                onClick={() => onClose()}
                className="fa fa-times fs-30"
                aria-hidden="true"
              />
            </div>
            <div className="text-center mb-5">
              <button
                className="w-50 od-btn-primary btn20 "
                style={{
                  backgroundColor: 'transparent',
                  color: 'white',
                  border: 'solid',
                  paddingBottom: '22px',
                }}
                onClick={() => {
                  prepStartAll(check, 'expo');
                  setIsOpen(false);
                }}
              >
                Bump Items
              </button>
            </div>
          </div>
        </Modal>
      </div>
      <Modal
        isOpen={isBumpConfirm}
        isModalCenter customClass2={styles.bumpModalMaxWidth}
        customClass3={styles.rad}
      >
        <div className={styles.bumpConfirmationModal}>
          <div className="px-3 py-2 text-right w-100" style={{ color: 'black' }}>
            <i
              role="presentation"
              onClick={() => { setBumpConfirmationModal(false); setLoaderId('') }}
              className="fa fa-times fs-30"
              aria-hidden="true"
            />
          </div>
          <div className={cn('text-center text-dark mb-3 ml-5 mr-5 fw-600')}>
            <p>{CUSTOM_MESSAGES().KDS_BUMP_CONFIRMATION}</p>
            <div>
              <button
                className={cn('rounded od-btn-primary color-dark btn-ripple w-40 m-3 border-dark h-10 p-2')}
                style={{ border: '1px solid black' }}
                onClick={() => { setBumpConfirmationModal(false); setLoaderId('') }}
              >
                {LABEL().NO}
              </button>
              <button
                style={{ border: '1px solid #0060FF' }}
                className={cn('rounded od-btn-primary color-white btn-ripple w-40 m-3 h-10 p-2', styles.popUpBtnColor)}
                onClick={() => {
                  setBumpConfirmationModal(false);
                  selectedObjects?.hasOwnProperty(check.id + '') && selectedObjects[check.id]?.length > 0 ?
                    bumpSelected(check, check.id + '') : bumpApiCall(check, 'expo');
                }}
              >
                {LABEL().YES}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
const KdsExpoStationCards = ({
  groupObj,
  inActiveData,
  bumpApiCall,
  toggle,
  prepStartAll,
  convertUTCDateToLocalDate = { convertUTCDateToLocalDate },
  columnCount,
  rowCount,
  themeProperties,
  bumpApiSelected,
  getPrepCompletedTime,
  duplicateDeviceIds,
  handleDropClick,
  prioritizedItem,
  setPriorityItem,
  isPrioritize,
  setPrioritize,
  handleLogout,
  duplicateData,
  layoutApi,
  activeScreenType,
  setToggle,
  setHistoryData,
  History,
  showMenu,
  setShowMenu,
  counter,
  loading,
  lastActiveTime,
  receipePdfApiCall,
  pdfUrl,
  setPdfUrl,
  setRecipeModalData,
  filterData,
  setFilterData,
  footerSelection,
  handleDragRushApiCall,
  handleIsStationEmpty
}) => {
  const [KeyboardOpen, setKeyboardOpen] = useState(true);
  const [searchString, setSearchString] = useState('');
  const array = Object.values(groupObj || {}).flat();
  const groupedOrderType = {};
  const nodes = [];
  const deviceInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('deviceInfo'), false)
  );
  const headerKeys = ['stationName', 'stationNumber', 'name'];
  const headerArray = headerKeys.map(i => {
    return {
      key: i,
    };
  });
  const [searchResults, setSearchResults] = useState(() => {
    return groupedOrderType;
  });
  const [activeNode, setActiveNode] = useState(() => {
    return nodes;
  });
  const [searchOverlay, setSearchOverlay] = useState(false);
  const [viewSingle, setViewSingle] = useState(() => {
    return { isOpen: false, data: {} };
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedObjects, setSelectedObjects] = useState({});
  const [headerCount, setHeaderCount] = useState({
    newOrder: 0,
    processCount: 0,
    inProgress: 0,
    yellowCount: 0,
    orangeCount: 0,
    redCount: 0
  })
  const [showTicketExpandModal, setShowTicketExpandModal] = useState(false);
  const [ticketExpandData, setTicketExpandData] = useState(null);
  let isItemInAllDay = false;

  useEffect(() => {
    setCurrentPage(0)
  }, [duplicateDeviceIds])

  useEffect(() => {
    setFilterData({})
  }, [toggle])

  const handleTicketExpandView = (data, headerColor) => {
    let val = { ...data }
    val['warningColor'] = headerColor;
    setShowTicketExpandModal(!showTicketExpandModal)
    setTicketExpandData(val)
  }

  const onSearchChange = string => {
    const key = string;
    setSearchString(string);
    const result = array.filter(item => createFilter(key, headerArray, item));
    (result || [])?.forEach(check => {
      if (nodes.indexOf(check.orderTypeId) === -1) {
        nodes.push(check.orderTypeId);
      }
      groupedOrderType[check.orderTypeId] = {
        groupName: check.orderTypeName,
        groupId: check.orderTypeId,
        list: [...(groupedOrderType[check.orderTypeId]?.list || []), check],
      };
    });
    setActiveNode(nodes);
    setSearchResults(groupedOrderType);
  };

  const getKeyboardStatus = status => {
    setKeyboardOpen(status);
  };
  const handleViewClick = check => {
    setSearchOverlay(false);
    setSearchString('');
    setViewSingle({ isOpen: true, data: { ...check } });
  };

  const handleActiveNode = id => {
    if (activeNode.indexOf(id) === -1) {
      setActiveNode(activeNode.concat(id));
    } else {
      setActiveNode(activeNode.filter(x => x !== id));
    }
  };
  const getWarning = item => {
    if (item.expoStatus === 5) {
      return true
    }
    const momentTime = moment.utc(item.plannedStartDate).local();
    const currentTime = moment();
    const diffTime = currentTime.diff(momentTime, 'seconds');
    const momentDate = momentTime.format('YYYY-MM-DD');
    let time;
    if (currentTime > momentTime) {
      time = moment(momentDate)
        .startOf('day')
        .seconds(diffTime)
        .format('mm:ss');
    } else {
      time = moment(momentDate)
        .startOf('day')
        .seconds(momentTime.diff(currentTime, 'seconds'))
        .format('mm:ss');
      time = ' - ' + time;
    }
    return time.includes('-') ? false : true;
  };

  const colorCoding = (item) => {
    const currentTime = Date.parse(
      moment()
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss')
    );

    if (item.expoStatus === 5) {
      const prepCompleteDate = item.prepCompleteDate
        ? Date.parse(item.prepCompleteDate)
        : '';
      const plannedPrepCompleteDate = item.plannedPrepCompleteDate
        ? Date.parse(item.plannedPrepCompleteDate)
        : '';
      const buildCompleteDate = item.buildCompleteDate
        ? Date.parse(item.buildCompleteDate)
        : '';
      const plannedBuildCompleteDate = item.plannedBuildCompleteDate
        ? Date.parse(item.plannedBuildCompleteDate)
        : '';
      const t1 =
        item.prepStatus === 0
          ? 0
          : prepCompleteDate
            ? prepCompleteDate - plannedPrepCompleteDate
            : currentTime - plannedPrepCompleteDate;
      const t2 =
        item.buildStatus === 0
          ? 0
          : buildCompleteDate
            ? buildCompleteDate - plannedBuildCompleteDate
            : currentTime - plannedBuildCompleteDate;

      let elapsedTime = Math.floor(Math.max(t1, t2) / 1000);
      if (
        deviceInfo.deviceGroup?.kdsWarningTime1 != 0 &&
        deviceInfo.deviceGroup?.kdsWarningTime1 != null
      ) {
        if (elapsedTime > 0) {
          if (elapsedTime >= deviceInfo.deviceGroup?.kdsWarningTime3) {
            return '#FF6464';
          } else if (elapsedTime >= deviceInfo.deviceGroup?.kdsWarningTime2) {
            return '#F49F40';
          } else if (elapsedTime >= deviceInfo.deviceGroup?.kdsWarningTime1) {
            return 'yellow';
          }
        }
      }
    }
    const prepStartDate = item.prepStartDate
      ? Date.parse(item.prepStartDate)
      : '';
    const plannedPrepStartDate = item.plannedPrepStartDate
      ? Date.parse(item.plannedPrepStartDate)
      : '';
    const buildStartDate = item.buildStartDate
      ? Date.parse(item.buildStartDate)
      : '';
    const plannedBuildStartDate = item.plannedBuildStartDate
      ? Date.parse(item.plannedBuildStartDate)
      : '';
    const t1 =
      item.prepStatus === 0
        ? 0
        : prepStartDate
          ? prepStartDate - plannedPrepStartDate
          : currentTime - plannedPrepStartDate;
    const t2 =
      item.buildStatus === 0
        ? 0
        : buildStartDate
          ? buildStartDate - plannedBuildStartDate
          : currentTime - plannedBuildStartDate;
    let elapsedTime = Math.floor(Math.max(t1, t2) / 1000);
    if (
      deviceInfo.deviceGroup?.kdsWarningTime1 != 0 &&
      deviceInfo.deviceGroup?.kdsWarningTime1 != null
    ) {
      if (elapsedTime > 0) {
        if (elapsedTime >= deviceInfo.deviceGroup?.kdsWarningTime3) {
          return '#FF6464';
        } else if (elapsedTime >= deviceInfo.deviceGroup?.kdsWarningTime2) {
          return '#F49F40';
        } else if (elapsedTime >= deviceInfo.deviceGroup?.kdsWarningTime1) {
          return 'yellow';
        }
      }
    }
  };

  useEffect(() => {
    let newArr = []
    let deviceIdTopush = {}
    for (let idx1 = 0; idx1 < inActiveData.length; idx1++) {
      const element = inActiveData[idx1];
      if (element?.expoItems && element.expoItems.length > 0) {
        for (let idx = 0; idx < element.expoItems.length; idx++) {
          let ele = element.expoItems[idx];
          if (ele.expoDeviceId && duplicateDeviceIds[ele.expoDeviceId]) {
            if (ele.expoStatus === 8) {
              let warningColor = getWarning(ele) && colorCoding(ele);
              if (element.id in deviceIdTopush) {
                ele['checkPrep'] = element;
                ele['warningColor'] = warningColor;
                deviceIdTopush[element.id].push(ele)
                newArr.pop()
                newArr.push({ ...deviceIdTopush })
              } else {
                ele['checkPrep'] = element;
                ele['warningColor'] = warningColor;
                deviceIdTopush[element.id] = [ele]
                newArr.push({ ...deviceIdTopush })
              }
            }
          }
        }
      }
    }
    setHistoryData(newArr[newArr.length - 1]);
  }, [groupObj])



  const noTicketCheck = (data) => {
    const newArr = []
    for (let idx1 = 0; idx1 < data.length; idx1++) {
      const element = data[idx1];
      if (element?.expoItems && element?.expoItems?.length > 0) {
        for (let idx = 0; idx < element?.expoItems?.length; idx++) {
          let ele = element?.expoItems[idx];
          if (deviceInfo?.deviceId === ele?.deviceId) {
            if (ele?.expoStatus >= 2 && ele?.expoStatus < 8) {
              newArr.push(ele);
            }
          }
        }
      }
    }
    return newArr
  }

  const checkData = groupObj => {
    let dataVal = [];
    let idx = -1;
    for (let index = 0; index < groupObj.length; index++) {
      let check = groupObj[index];
      let page;

      if (!toggle) {
        if (check.expoDeviceId && duplicateDeviceIds[check.expoDeviceId]) {
          if ((check?.expoStatus > 2 && check.expoStatus < 8) ||
            (check?.expoStatus == 2 && check?.plannedExpoStartDate &&
              convertUTCDateToLocalDate(new Date(check?.plannedExpoStartDate)).getTime() > (new Date().getTime())
            )
          ) {
            isItemInAllDay = true;
          }
          if (
            ((check.expoStatus > 2 && check.expoStatus < 8) ||
              (check.expoStatus == 2 &&
                check?.plannedExpoStartDate &&
                convertUTCDateToLocalDate(
                  new Date(check?.plannedExpoStartDate)
                ).getTime() <= new Date().getTime()))) {
            let c = { ...check };
            if (Object.keys(filterData)?.length !== 0) {
              let arr = []
              for (let i = 0; i < check.expoItems.length; i++) {
                if (Object.values(filterData)?.includes(true)) {
                  if (filterData?.[check.expoItems[i].name] === true) {
                    arr.push(check.expoItems[i])
                  }
                }
                else {
                  arr.push(check.expoItems[i])
                }
              }

              c.expoItems = arr
            }
            if (c.expoItems.length > 0) {
              idx += 1;
              if (columnCount && rowCount) {
                page = Math.floor(idx / (columnCount * rowCount));
              } else {
                page = Math.floor(idx / 8);
              }
              (dataVal[page] = dataVal[page] || []).push({ ...c });
            }
          }
        }

      }
      else {
        if (check.expoDeviceId && duplicateDeviceIds[check.expoDeviceId]) {
          if (check.expoStatus >= 2 && check.expoStatus < 8) {
            let c = { ...check };
            if (Object.keys(filterData)?.length !== 0) {
              let arr = []
              for (let i = 0; i < check.expoItems.length; i++) {
                if (Object.values(filterData)?.includes(true)) {
                  if (filterData?.[check.expoItems[i].name] === true) {
                    arr.push(check.expoItems[i])
                  }
                }
                else {
                  arr.push(check.expoItems[i])
                }
              }
              c.expoItems = arr
            }
            if (c.expoItems.length > 0) {
              idx += 1;
              if (columnCount && rowCount) {
                page = Math.floor(idx / (columnCount * rowCount));
              } else {
                page = Math.floor(idx / 8);
              }
              (dataVal[page] = dataVal[page] || []).push({ ...c });
            }
          }
        }
      }
    }
    if (dataVal.length > 0 && dataVal.length - 1 - currentPage === -1) {
      setCurrentPage(currentPage - 1);
    }
    handleIsStationEmpty((dataVal.length <= 0))
    return dataVal.length > 0 ? dataVal : [];
  };
  let grpModify = (data) => {
    let dataVal = [];
    for (let index = 0; index < data.length; index++) {
      let check = data[index];
      if (!toggle) {
        if (check.expoDeviceId && duplicateDeviceIds[check.expoDeviceId]) {
          if (
            ((check.expoStatus > 2 && check.expoStatus < 8) ||
              (check.expoStatus == 2 &&
                check?.plannedExpoStartDate &&
                convertUTCDateToLocalDate(
                  new Date(check?.plannedExpoStartDate)
                ).getTime() <= new Date().getTime()))) {
            dataVal.push({ ...check })
          }

        }
      } else {
        if (check.expoDeviceId && duplicateDeviceIds[check.expoDeviceId]) {
          if (
            ((check.expoStatus > 2 && check.expoStatus < 8) ||
              (check.expoStatus == 2 &&
                check?.plannedExpoStartDate &&
                convertUTCDateToLocalDate(
                  new Date(check?.plannedExpoStartDate)
                ).getTime() <= new Date().getTime()))) {
            dataVal.push({ ...check })
          }
          else if (check.expoStatus >= 2 && check.expoStatus < 8) {
            dataVal.push({ ...check })
          }
        }
      }
    }
    return dataVal;
  }

  let arr = grpModify(groupObj).map(obj => obj?.expoItems || [])
  const flatArr = arr.reduce((acc, curr) => {
    return acc.concat(curr);
  }, []);
  const count = flatArr.reduce((acc, curr) => {
    if (curr) {
      const name = curr.name;
      if (typeof acc[name] === 'undefined') {
        acc[name] = { count: 1, notSchedule: 0, Schedule: 0, expoStatus: curr.expoStatus, plannedStartDate: curr.plannedStartDate };
        if (
          ((curr.expoStatus > 2 && curr.expoStatus < 8) ||
            (curr.expoStatus == 2 &&
              curr?.plannedExpoStartDate &&
              convertUTCDateToLocalDate(
                new Date(curr?.plannedExpoStartDate)
              ).getTime() <= new Date().getTime()))) {
          acc[name].Schedule += 1;
        } else {
          acc[name].notSchedule += 1;
        }
      }
      else {
        if (
          ((curr.expoStatus > 2 && curr.expoStatus < 8) ||
            (curr.expoStatus == 2 &&
              curr?.plannedExpoStartDate &&
              convertUTCDateToLocalDate(
                new Date(curr?.plannedExpoStartDate)
              ).getTime() <= new Date().getTime()))) {
          acc[name].Schedule += 1;
        } else {
          acc[name].notSchedule += 1;
        }
      }

      return acc;
    }
  }, {});
  const result = [];

  for (const key in count) {
    result.push({ name: key, count: count[key].count, notSchedule: count[key].notSchedule, Schedule: count[key].Schedule, prepStatus: count[key].prepStatus, plannedPrepStartDate: count[key].plannedPrepStartDate, prepDeviceId: count[key].prepDeviceId });
  }
  // function to clear filterData if all items on screen are bumped.
  (() => {
    if (Object.values(filterData)?.length > 0) {
      const tempArr = []
      for (let key in filterData) {
        if (filterData[key] === true) tempArr.push(key)
      }

      if (tempArr?.length > 0) {
        const arr = tempArr?.map(el => result?.some(val => val?.name === el))

        if (arr?.every((el) => el === false)) {
          setFilterData({})
        }
      }

    }
  })();

  const getDisplayStyle = () => {
    let height = 50;
    let width = 25;
    if (columnCount && rowCount) {
      width = 100 / columnCount
      height = 100 / rowCount
    }
    return { height: `${height}%`, width: `${width}%` };
  };

  const tileHeightForTwoRows = (item) => {
    if (item) {
      if (item?.hasAllergy && (!item?.offPremise && item?.courseName) && item?.doNotMake && item?.checkedIn && item?.checkInNote) {
        if (window?.innerHeight <= 530) { return '25%'; }
        else { return '28%'; }
      }
      if (item?.hasAllergy && (!item?.offPremise && item?.courseName) && item?.doNotMake) {
        if (window?.innerHeight <= 530) { return '25%'; }
        else { return '35%'; }
      }
      if (item?.hasAllergy && item?.offPremise && item?.doNotMake) {
        if (window?.innerHeight <= 530) { return '19%'; }
        return '29%';
      }
      if ((item?.hasAllergy && ((!item?.offPremise && item?.courseName) || item?.offPremise || item?.doNotMake)) ||
        (!item?.hasAllergy && ((!item?.offPremise && item?.courseName) || item?.offPremise) && item?.doNotMake) ||
        ((!item?.offPremise && item?.courseName) && item?.checkedIn && item?.checkInNote)
      ) {
        if (window?.innerHeight <= 530) { return item?.offPremise ? "26%" : '35%'; }
        else { return item?.offPremise ? "37%" : "42%"; }
      }
      if (item?.hasAllergy || (!item?.offPremise && item?.courseName) || item?.doNotMake) {
        if (window?.innerHeight <= 530) { return '45%'; }
        else { return '50%' }
      }
      if (item?.offPremise) {
        return '43%'
      }
    }
  }

  const getTileHeight = (item) => {

    if (rowCount && columnCount) {
      if (rowCount === 4) {
        return '35%'
      } else if (rowCount === 3) {
        return '40%'
      } else if (rowCount === 2) {
        const tileHeight = tileHeightForTwoRows(item)
        if (tileHeight) return tileHeight;
        return '60%'
      } else if (rowCount === 1) {
        if (item?.hasAllergy && (!item?.offPremise && item?.courseName) && item?.doNotMake) {
          if (window?.innerHeight <= 530) { return '63%'; }
          else { return '67%'; }
        }
        if ((item?.hasAllergy && ((!item?.offPremise && item?.courseName) || item?.offPremise || item?.doNotMake)) ||
          (!item?.hasAllergy && ((!item?.offPremise && item?.courseName) || item?.offPremise) && item?.doNotMake)
        ) {
          if (window?.innerHeight <= 530) { return '68%'; }
          else { return '72%'; }
        }
        if (item?.hasAllergy || (!item?.offPremise && item?.courseName) || item?.doNotMake) {
          if (window?.innerHeight <= 530) { return '73%'; }
          else { return '76%' }
        }

        if (window?.innerHeight <= 530) { return '78%' }
        else { return '80%'; }
      }
    }

    if (item) {
      const tileHeight = tileHeightForTwoRows(item);
      if (tileHeight) return tileHeight;
    }

    return '60%'
  };

  const getTime = date => {

    if (date === null) {
      return true;
    }
    const momentTime = moment.utc(date).local();
    const currentTime = moment();
    return currentTime > momentTime ? true : false;
  };

  useLayoutEffect(() => {
    if (viewSingle?.isOpen) {
      const array = Object.values(groupObj || {}).flat();
      const result = array.find(d => d.id === viewSingle?.data?.id);
      setViewSingle({
        ...viewSingle,
        data: result,
      });
    }
    if (searchOverlay) {
      const result = array.filter(item =>
        createFilter(searchString, headerArray, item)
      );
      (result || [])?.forEach(check => {
        groupedOrderType[check.orderTypeId] = {
          groupName: check.orderTypeName,
          groupId: check.orderTypeId,
          list: [...(groupedOrderType[check.orderTypeId]?.list || []), check],
        };
      });
      setSearchResults(groupedOrderType);
    }
  }, [groupObj]);

  const generateHeaderColor = (data) => {
    //green
    let defaultColor = '#18BD63'

    const kdsWarningTime1 = deviceInfo.deviceGroup?.kdsWarningTime1;
    const kdsWarningTime2 = deviceInfo.deviceGroup?.kdsWarningTime2;
    const kdsWarningTime3 = deviceInfo.deviceGroup?.kdsWarningTime3;
    let greenFlag = false;

    const plannedCompleteDate = moment.utc(data.plannedCompleteDate);
    const plannedStartDate = moment.utc(data.plannedStartDate);
    const currentTime = moment();

    const isPastCompleteDate = currentTime.isAfter(plannedCompleteDate, 'seconds');
    const isUnscheduled = currentTime.isBefore(plannedStartDate, 'seconds');

    if (isPastCompleteDate) {
      const diff = currentTime.diff(plannedCompleteDate, 'seconds')

      if (diff > kdsWarningTime1 && diff <= kdsWarningTime2) {
        defaultColor = 'yellow';
      }
      else if (diff > kdsWarningTime2 && diff <= kdsWarningTime3) {
        // orange
        defaultColor = '#F49F40';
      }
      else if (diff > kdsWarningTime3) {
        // red
        defaultColor = '#FF6464'
      }
    }
    else if (isUnscheduled && !greenFlag) {
      defaultColor = 'gray'
    }

    if (!isPastCompleteDate && !isUnscheduled) {
      // green
      defaultColor = '#18BD63';
    }
    return defaultColor;
  }

  useEffect(() => {
    const pageData = !viewSingle?.isOpen && groupObj?.length > 0 && checkData(groupObj)[currentPage]?.length > 0 && checkData(groupObj) || [];
    let newOrder = 0, processCount = 0, inProgress = 0, yellowCount = 0, orangeCount = 0, redCount = 0;
    pageData?.forEach(data => {
      data.forEach((check) => {
        let warningColorId = generateHeaderColor(check);
        const colorId = (!warningColorId && warningColorId != 0) || warningColorId === 'black' ? 1 : warningColorId === 'yellow' ? 2 : warningColorId === '#F49F40' ? 3 : warningColorId === '#FF6464' ? 4 : warningColorId;
        let id = 1;
        check?.expoItems?.forEach((item) => {
          if (item?.expoStatus == 2) {
            processCount += 1;
          } if (item?.expoStatus == 5) {
            inProgress += 1;
          }

        });
        if (check.receivedDate > lastActiveTime) {
          newOrder += 1
        }
        if (colorId > id) id = colorId;
        switch (id) {
          case 2: yellowCount += 1;
            break;
          case 3: orangeCount += 1;
            break;
          case 4: redCount += 1;
            break;
        }
      })
    });
    setHeaderCount({ newOrder, processCount, inProgress, yellowCount, orangeCount, redCount })
  }, [groupObj, counter]);

  return (
    <>
      <Navbar
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        PrepFooter={PrepFooter}
        result={result}
        footerSelection={footerSelection}
        filterData={filterData}
        setCurrentPage={setCurrentPage}
        newOrder={headerCount.newOrder}
        processCount={headerCount.processCount}
        inProgress={headerCount.inProgress}
        yellowCount={headerCount.yellowCount}
        orangeCount={headerCount.orangeCount}
        redCount={headerCount.redCount}
        station='expo'
        setToggle={setToggle}
        toggle={toggle}
        isPrioritize={isPrioritize}
        setPrioritize={setPrioritize}
        setPriorityItem={setPriorityItem}
      />
      {
        showMenu && <HamburgerSideBarMenu setShowMenu={setShowMenu} handleLogout={handleLogout} duplicateData={duplicateData} layoutApi={layoutApi} activeScreenType={activeScreenType} History={History} />
      }
      <div
        className={cn(
          'p-0 h-80 align-content-start row overflowX overflowYHidden mx-0 w-100 col-12 p-1',
          styles.grid
        )}
      // style={{ width: '92%' }}
      >
        {!viewSingle?.isOpen &&
          groupObj.length > 0 &&
          checkData(groupObj)[currentPage]?.length > 0 ?
          checkData(groupObj)[currentPage].map((check, i) => {
            return (
              <div
                role="presentation"
                className={cn('px-0', !(rowCount && columnCount) && 'col-3')}
                style={{
                  marginBottom: '0.2%',
                  paddingBottom: '0.2%',
                  paddingLeft: '0 !important',
                  paddingRight: '0 !important',
                  color: 'black',
                  height: getDisplayStyle().height,
                  width: rowCount && columnCount ? getDisplayStyle().width : 'none',
                }}
              >
               <StationCard
                  check={check}
                  searchOverlay={searchOverlay}
                  bumpApiCall={bumpApiCall}
                  receipePdfApiCall={receipePdfApiCall}
                  prepStartAll={prepStartAll}
                  convertUTCDateToLocalDate={convertUTCDateToLocalDate}
                  themeProperties={themeProperties}
                  selectedObjects={selectedObjects}
                  setSelectedObjects={setSelectedObjects}
                  bumpApiSelected={bumpApiSelected}
                  getTileHeight={getTileHeight}
                  getPrepCompletedTime={getPrepCompletedTime}
                  index={i}
                  duplicateDeviceIds={duplicateDeviceIds}
                  handleDropClick={handleDropClick}
                  prioritizedItem={prioritizedItem}
                  setPriorityItem={setPriorityItem}
                  isPrioritize={isPrioritize}
                  getWarning={getWarning}
                  colorCoding={colorCoding}
                  deviceInfo={deviceInfo}
                  handleTicketExpandView={handleTicketExpandView}
                  currentPage={currentPage}
                  getTime={getTime}
                  loading={loading}
                  lastActiveTime={lastActiveTime}
                  pdfUrl={pdfUrl}
                  setPdfUrl={setPdfUrl}
                  rowCount={rowCount}
                  generateHeaderColor={generateHeaderColor}
                  setRecipeModalData={setRecipeModalData}
                  filterData={filterData}
                  handleDragRushApiCall={handleDragRushApiCall}
                />
              </div>
            );
          }) : <> {(noTicketCheck(groupObj).length === 0 && !isItemInAllDay) && <div className='text-center w-50' style={{ height: '15vw', position: 'fixed', top: '20vw', left: '25%' }}>
            <div className='font-weight-bold' style={{ position: 'absolute', top: '6vw', left: '20%', color: 'black' }}>NO TICKETS AVAILABLE RIGHT NOW
            </div>
          </div>}</>}
        {
          showTicketExpandModal && <div className={styles.overlay}>
            <TicketExpandModal ticketExpandData={ticketExpandData}
              handleTicketExpandView={handleTicketExpandView}
              searchOverlay={searchOverlay}
              bumpApiCall={bumpApiCall}
              prepStartAll={prepStartAll}
              convertUTCDateToLocalDate={convertUTCDateToLocalDate}
              themeProperties={themeProperties}
              selectedObjects={selectedObjects}
              setSelectedObjects={setSelectedObjects}
              bumpApiSelected={bumpApiSelected}
              getTileHeight={getTileHeight}
              getPrepCompletedTime={getPrepCompletedTime}
              duplicateDeviceIds={duplicateDeviceIds}
              handleDropClick={handleDropClick}
              prioritizedItem={prioritizedItem}
              setPriorityItem={setPriorityItem}
              isPrioritize={isPrioritize}
              getWarning={getWarning}
              colorCoding={colorCoding}
              deviceInfo={deviceInfo}
              receipePdfApiCall={receipePdfApiCall}
              setPdfUrl={setPdfUrl}
              setRecipeModalData={setRecipeModalData}
              handleDragRushApiCall={handleDragRushApiCall}
            />
          </div>
        }

        {searchOverlay && (
          <div className="position-absolute w-100 h-100">
            <div className="h-10 w-100">
              <SearchComponent
                onChange={e => onSearchChange(e)}
                autoKeyboard
                getKeyboardStatus={getKeyboardStatus}
              />
            </div>
            <div
              className={cn(
                'overflowY w-100 p-1 rounded',
                KeyboardOpen ? 'h-50' : 'h-90'
              )}
            >
              {Object.keys(searchResults)?.length > 0 &&
                Object.values(searchResults || {})?.map(
                  ({ groupName, groupId, list }) => {
                    return (
                      <div className="d-flex flex-wrap fs-20 fw-600 text-capitalize">
                        <div className="w-90 text-left">{`${groupName} (${list.length})`}</div>
                        <div
                          role="presentation"
                          onClick={() => handleActiveNode(groupId)}
                          className="w-10 text-right"
                        >
                          {activeNode.includes(groupId) ? (
                            <i className="fa fa-chevron-up" aria-hidden="true" />
                          ) : (
                            <i className="fa fa-chevron-down" aria-hidden="true" />
                          )}
                        </div>
                        {activeNode.includes(groupId) &&
                          list?.length > 0 &&
                          list?.map(check => {
                            return (
                              <div
                                className={cn(
                                  'col-4 p-2 color-black fs-18 fw-600'
                                )}
                              >
                                <div className="rounded bg-dark row mx-0 align-content-start p-2">
                                  <div className="w-80 p-0 text-truncate">
                                    {check.name ||
                                      check.stationName ||
                                      check.stationNumber}
                                  </div>
                                  <div
                                    role="presentation"
                                    onClick={() => handleViewClick(check)}
                                    className="w-20 d-flex justify-content-center color-white align-items-center text-center p-0 bg-lightblue rounded align-self-stretch fs-18"
                                  >
                                    {LABEL().VIEW}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    );
                  }
                )}
            </div>
          </div>
        )}
        {viewSingle?.isOpen && (
          <div className="p-1 w-100 h-100">
            {[viewSingle?.data]?.map(check => {
              return (
                <div className="h-100 w-100">
                  <StationCard
                    check={check}
                    searchOverlay={searchOverlay}
                    convertUTCDateToLocalDate={convertUTCDateToLocalDate}
                    getTime={getTime}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
      <Footer
        checkData={checkData}
        groupObj={groupObj}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        station='expo'
        result={result}
        filterData={filterData}
        footerSelection={footerSelection}
        setToggle={setToggle}
        toggle={toggle}
        setPrioritize={setPrioritize}
        isPrioritize={isPrioritize}
        setPriorityItem={setPriorityItem}
      />
    </>
  );
};

const mapStateToProps = ({ storeChecks }) => ({
  loading: storeChecks.bumpLoading
})
export default connect(mapStateToProps, null)(KdsExpoStationCards)
